import React from 'react';
import { Button, Space } from 'antd';
import { useLocation, history } from '@umijs/max';
import { isSecondaryPage, getPageTitle } from '@/utils/breadcrumb';
import { generateBreadcrumbFromRoutes } from '@/utils/breadcrumbFromRoutes';
import './index.less';

interface PageHeaderProps {
  // 可选的自定义面包屑，如果不提供则自动生成
  breadcrumb?: string;
  // 可选的自定义标题，如果不提供则自动生成
  title?: string;
  // 返回按钮点击事件
  onBack?: () => void;
  // 右侧操作按钮
  children?: React.ReactNode;
  // 自定义样式类名
  className?: string;
  // 是否强制显示为二级页面样式（面包屑 + 按钮）
  forceSecondary?: boolean;
  // 是否强制显示为一级页面样式（只显示标题）
  forcePrimary?: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  breadcrumb,
  title,
  onBack,
  children,
  className = '',
  forceSecondary = false,
  forcePrimary = false,
}) => {
  const location = useLocation();
  const pathname = location.pathname;

  // 自动生成标题
  const autoTitle = getPageTitle(pathname);

  // 判断页面类型
  const isSecondary = forceSecondary || (!forcePrimary && isSecondaryPage(pathname));
  const isPrimary = forcePrimary || (!forceSecondary && !isSecondaryPage(pathname));

  // 确定显示内容
  const displayTitle = title || autoTitle;

  // 使用基于路由配置的面包屑生成
  const clickableBreadcrumb = generateBreadcrumbFromRoutes(pathname);

  return (
    <div className={`custom-page-header ${className}`}>
      <div className="page-header-content">
        <div className="page-header-left">
          {isSecondary ? (
            <div className="breadcrumb-text">
              {clickableBreadcrumb.map((item, index) => (
                <span key={index}>
                  {item.clickable ? (
                    <span
                      className="breadcrumb-link"
                      onClick={() => history.push(item.path)}
                      style={{ cursor: 'pointer', color: '#1890ff' }}
                    >
                      {item.name}
                    </span>
                  ) : (
                    <span style={{ color: '#000' }}>{item.name}</span>
                  )}
                  {index < clickableBreadcrumb.length - 1 && (
                    <span style={{ margin: '0 8px', color: '#999' }}>/</span>
                  )}
                </span>
              ))}
            </div>
          ) : (
            <div className="page-title">
              {displayTitle}
            </div>
          )}
        </div>
        {(isSecondary || children) && (
          <div className="page-header-right">
            <Space>
              {children}
            </Space>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
